import {
  ChangeEvent,
  DragEvent,
  FC,
  SyntheticEvent,
  useRef,
  useState,
} from "react";
import { toast } from "react-toastify";

import { ReactComponent as UploadFileIcon } from "../../assets/icons/uploadImage.svg";
import Modal from "../../global/Modal/Modal";
import SimpleButton from "../../global/SimpleButton/SimpleButton";
import { addEditDataAPI } from "../../services/CRUDServices";

interface AddExcelProps {
  OpenModal: boolean;
  setOpenModal: (value: boolean) => void;
  setUpdate?: () => void;
}

const UploadFile: FC<AddExcelProps> = ({
  OpenModal,
  setOpenModal,
  setUpdate,
}): JSX.Element => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [theFile, setTheFile] = useState<any>();
  const [dragActive, setDragActive] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleDrag = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      if (
        e.dataTransfer.files[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setTheFile(e.dataTransfer.files[0]);
      } else {
        toast.error("فرمت فایل صحیح نیست");
      }
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      setTheFile(e.target.files[0]);
    } else {
      toast.error("فرمت فایل صحیح نیست");
    }
  };

  const handleClear = () => {
    setTheFile(null);
    setOpenModal(false);
  };

  const handleOpenUpload = () => inputRef?.current?.click();

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();

    if (theFile) {
      let bodyFormData = new FormData();
      bodyFormData.append("file", theFile);
      // excelInfo.Entity && bodyFormData.append("Entity", excelInfo.Entity);
      setLoading(true);
      addEditDataAPI("uyiy", "post", bodyFormData, true)
        .then((response: any) => {
          toast.success("اطلاعات مورد نظر اضافه شد ");
          setOpenModal(false);
          handleClear();
          setLoading(false);
          setUpdate && setUpdate();
        })
        .catch(() => setLoading(false));
    }
  };


  return (
    <>
      <form onSubmit={handleSubmit} className="centering flex-col w-[30rem]">
        <div className="text-center mb-5 w-full" onDragEnter={handleDrag}>
          <input
            accept="image/png, image/gif, image/jpeg"
            type="file"
            id="input-file-upload"
            ref={inputRef}
            multiple={true}
            onChange={handleChange}
            className="hidden"
          />
          <label
            id="label-file-upload"
            htmlFor="input-file-upload"
            className={`centering border-2 border-dashed border-[#CCCCCC] bg-[#F9FAFC]  py-3 rounded-lg ${
              dragActive ? "bg-lightTomato" : "bg-light"
            } `}
          >
            <div className="my-4 centering flex-col gap-3  ">
              <UploadFileIcon />
              <p className="text-base text-darkGray leading-7 text-center">
                فایل را در این قسمت بکشید و رها کنید <br />
                یا یک
                <button
                  type="button"
                  className="px-1 text-tomato underline cursor-pointer"
                  onClick={handleOpenUpload}
                >
                  فایل آپلود
                </button>
                کنید
              </p>
              <span className={`my-2 ${theFile ? "text-green" : "text-red"}`}>
                {theFile ? theFile?.name : "فایلی وجود ندارد"}
              </span>
            </div>
          </label>
          {dragActive && (
            <div
              className="absolute w-full h-full rounded-[1px] top-0	right-0 bottom-0 left-0	"
              id="drag-file-element"
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
            ></div>
          )}
        </div>
      </form>
    </>
  );
};

export default UploadFile;
